import moment from "moment-timezone";
import type { Todo } from "@common/types/todo";

export function timeStrToSeconds(timeStr: string) {
  let duration = 0;
  let days = timeStr.match(/(\d+(?:\.\d+)?)\s*d/);
  let hours = timeStr.match(/(\d+(?:\.\d+)?)\s*h/);
  let minutes = timeStr.match(/(\d+(?:\.\d+)?)\s*m/);
  let seconds = timeStr.match(/(\d+(?:\.\d+)?)\s*s/);
  if (days) {
    duration += parseFloat(days[1]!) * 86400;
  }
  if (hours) {
    duration += parseFloat(hours[1]!) * 3600;
  }
  if (minutes) {
    duration += parseFloat(minutes[1]!) * 60;
  }
  if (seconds) {
    duration += parseFloat(seconds[1]!);
  }

  return duration;
}
export function millisecondsToTimeStr(milliseconds: number) {
  return secondsToTimeStr(milliseconds / 1000);
}

export function secondsToTimeStr(seconds: number) {
  let duration = moment.duration(seconds, "seconds").abs();

  let str = "";
  let d = duration.days();
  let h = duration.hours();
  let m = duration.minutes();
  let s = duration.seconds();

  const components = [];
  if (d) components.push(`${d}d`);

  if (h) components.push(`${h}h`);

  if (m) components.push(`${m}m`);

  if (s) components.push(`${s}s`);

  return components.length ? components.join(" ") : "0s";
}

export function formatDuration(milliseconds: number, format: string) {
  return moment.utc(milliseconds).format(format);
}

export function isTodoBeforeToday(todo: Todo, timezone: string) {
  // todo date time is assumed to be in UTC.
  // find start of day in user's timezone

  const timezoneExists = moment.tz.names().includes(timezone);
  if (!timezoneExists) {
    console.error("timezone does not exist:", timezone);
  }

  let startOfDayInTimezone = moment.tz(timezone).startOf("day");
  return (
    todo.date !== null &&
    moment.utc(todo.date).isBefore(startOfDayInTimezone.utc())
  );
}

export function startOfDayTimezone(timezone: string) {
  return moment.tz(timezone).startOf("day").valueOf();
}
